import SelectedBrandsPage from '../module/newShop/home/selectedBrandsPage';
import ProtectedRoute from '../utilities/protection/ProtectedRoute';
import MyCreditsPage from '../pages/myAccount/my-credits/MyCreditsPage';
import StartLoanCreditPage from '../pages/myAccount/my-credits/step0-startLoanCredit/StartLoanCreditPage';
import MyOrders from '../pages/myAccount/my-orders/MyOrders';
import OrderDetail from '../pages/myAccount/my-orders/order-detail/OrderDetail';
import MyNotifications from '../pages/notification/MyNotifications';
import Receipt from '../pages/receipt';
import Failed from '../pages/receipt/failed';
import Success from '../pages/receipt/success';
import ActivePlanPage from '../pages/sponsor/activePlane';
import CreateActivePlan from '../pages/sponsor/CreateActivePlan';
import OldPlanPage from '../pages/sponsor/old-plan';
import MyStoreAddLocationByMap from '../pages/farm/addLocationByMap';
import AddPicture from '../pages/farm/addPicture';
import AdvertisementList from '../pages/farm/advertisementList';
import AdvertisementListForAll from '../pages/farm/advertisementListForAll';
import AdverAddPicture from '../pages/farm/advertisementRegisteration/pages/adverAddPicture';
import BrandSelect from '../pages/farm/advertisementRegisteration/pages/brandList/BrandSelect';
import SubBrandSelect from '../pages/farm/advertisementRegisteration/pages/brandList/SubBrandSelect';
import AdvertisementRegisteration from '../pages/farm/advertisementRegisteration/pages/home';
import OptionalInfoAR from '../pages/farm/advertisementRegisteration/pages/optionalInfo';
import SubInputList from '../pages/farm/advertisementRegisteration/pages/subInputList';
import AdvertismentDetail from '../pages/farm/advertismentDetail';
import BackUp from '../pages/farm/backup';
import CreateBrand from '../pages/farm/brand';
import AddProduct from '../pages/farm/brand/addProduct';
import BuyersListing from '../pages/farm/buyersListing';
import CategoriesPage from '../pages/farm/categories';
import CategoryCardDetail from '../pages/farm/CategoryCardDetail';
import ChatFormAddImage from '../pages/farm/chatFormAddImage';
import ChatsForm from '../pages/farm/chats-form';
import ChooseLocation from '../pages/farm/chooseLocation';
import CommentsListing from '../pages/farm/commentsListing';
import CustomersPointOfView from '../pages/farm/CustomersPointOfView';
import EditAdds from '../pages/farm/editAds/pages';
import EditMyAccountWrapper from '../pages/farm/editMyAccount';
import Faq from '../pages/farm/faq';
import HomePage from '../pages/farm/home';
import LabDetails from '../pages/farm/labDetails';
import LabListing from '../pages/farm/labListing';
import MyAccess from '../pages/farm/myAccess';
import MyAccountWrapper from '../pages/farm/myAccount';
import MyAdds from '../pages/farm/myAds';
import MyChats from '../pages/farm/myChats';
import MyFavouriteAdd from '../pages/farm/myFavouriteAdd';
import MyStore from '../pages/farm/myStore';
import SaleAgentLocationByMap from '../pages/farm/myStore/elements/saleAgentLocationByMap';
import SaleAgentSearchingLocation from '../pages/farm/myStore/elements/saleAgentSearchingLocation';
import MyStoreComments from '../pages/farm/myStore/pages/comments';
import EditRegisterLab from '../pages/farm/myStore/pages/editRegisterLab';
import EditRegisterStore from '../pages/farm/myStore/pages/editRegisterStore';
import GuideStory from '../pages/farm/myStore/pages/guideStory';
import LabStoreAdditionalMainInfo from '../pages/farm/myStore/pages/labStoreAdditionalMainInfo';
import ManageMyStoreAds from '../pages/farm/myStore/pages/manageMyStoreAds';
import EditBulkStoreAdsPage from '../pages/farm/myStore/pages/manageMyStoreAds/editBulkStoreAdsPage';
import PreviewAndEditAdPricePage from '../pages/farm/myStore/pages/manageMyStoreAds/PreviewAndEditAdPricePage';
import MyLabAdvertisement from '../pages/farm/myStore/pages/myLabAdvertisement';
import MyStoreAddPicture from '../pages/farm/myStore/pages/myStoreAddPicture';
import MyStoreAdvertisement from '../pages/farm/myStore/pages/myStoreAdvertisement';
import MyStoreCommentsListing from '../pages/farm/myStore/pages/myStoreCommentsListing/index';
import MyStoreInfo from '../pages/farm/myStore/pages/myStoreInfo';
import MyStoreBrandsPage from '../pages/farm/myStore/pages/myStoreInfo/myStoreBrands';
import MyStoreOrderDetail from '../pages/farm/myStore/pages/myStoreOrders/my-store-order-detail/MyStoreOrderDetail';
import MyStoreOrders from '../pages/farm/myStore/pages/myStoreOrders/myStoreOrders';
import MyStoreSaleAgents from '../pages/farm/myStore/pages/myStoreSaleAgents';
import MyStoreSalesPartnershipAgreement from '../pages/farm/myStore/pages/myStoreSalesPartnershipAgreement';
import MyStorePartnershipAgreementLicense from '../pages/farm/myStore/pages/myStoreSalesPartnershipAgreement/myStorePartnershipAgreementLicense';
import RegisterLab from '../pages/farm/myStore/pages/registerLab';
import RegisterStore from '../pages/farm/myStore/pages/registerStore';
import RegisterStoreLab from '../pages/farm/myStore/pages/registerStoreLab';
import SalesAgents from '../pages/farm/myStore/pages/salesAgents';
import SetStory from '../pages/farm/myStore/pages/setStory';
import MyStoreSettlementsOrders from '../pages/farm/myStore/pages/settlementAndPayouts';
import OffersListing from '../pages/farm/offersListing';
import PaymentFailure from '../pages/farm/PaymentFailure';
import PaymentLoading from '../pages/farm/paymentLoading';
import PaymentPlanLoading from '../pages/farm/paymentPlanLoading';
import PaymentPlanSuccess from '../pages/farm/paymentPlanSuccess';
import PaymentSuccess from '../pages/farm/paymentSuccess';
import ProductDetail from '../pages/farm/productDetail';
import MyStoreSubBrandDetail from '../pages/farm/productDetail/MyStoreSubBrandDetail';
import SaleAgentsPage from '../pages/farm/productDetail/saleAgentsPage';
import ProductsPage from '../pages/farm/products/ProductsPage';
import ProductShopsList from '../pages/farm/productShopsList';
import RegisteringSearchingLocation from '../pages/farm/registeringSearchingLocation';
import RequirementDetail from '../pages/farm/requirementDetail';
import Rules from '../pages/farm/rules';
import SaleAgentsList from '../pages/farm/saleAgentsList';
import SearchingLocation from '../pages/farm/searchingLocation';
import SearchStore from '../pages/farm/searhStore';
import BrandProducts from '../pages/farm/shopDetails/BrandProducts';
import MyStoreSubBrands from '../pages/farm/shopDetails/BrandProducts/MyStoreSubBrands';
import SelectShopAdvertisementByInput from '../pages/farm/shopDetails/selectShopAdvertisementByInput';
import ShopSelectInputAds from '../pages/farm/shopDetails/shopSelectInputAds';
import ShopListing from '../pages/farm/shopListing';
import StoreSaleAgentsList from '../pages/farm/storeSaleAgentsList';
import UpgradeAccount from '../pages/farm/upgradeAccount';
import UpgradeAccountRequirement from '../pages/farm/UpgradeAccountRequirement';
import UpgradePlanCardToCard from '../pages/farm/UpgradePlanCardToCard';
import UpgradePrmotionCardToCard from '../pages/farm/UpgradePrmotionCardToCard';
import ViolationReportAdvertisement from '../pages/farm/violationReportAdvertisement';
import ViolationReportStore from '../pages/farm/violationReportStore';
import type {AppRouteConfig} from './route.types';
import AccounPromotion from '../pages/farm/accounPromotion';
import AddLocation from '../pages/farm/addLocation';
import ShopDetails from '../pages/farm/shopDetails';

/**
 * Everything here used to live behind a single `<Route element={<ProtectedRoute />}>`
 * wrapper in FarmShopRoutes.tsx. That wrapper is now just the pathless parent below —
 * ProtectedRoute still renders <Outlet /> / <Navigate /> exactly as before.
 * The old `path="*"` NotFound catch-all now lives once, globally, in AppRouter.tsx.
 */
export const farmShopRoutes: AppRouteConfig[] = [
  {
    element: ProtectedRoute,
    children: [
      // ==================== CORE & NAVIGATION ====================
      {index: true, redirectTo: 'home'},
      {path: 'home', element: HomePage},
      {path: 'categories', element: CategoriesPage},

      // ==================== SPONSOR & PAYMENT ROUTES ====================
      {path: 'sponsor/new-plan', element: CreateActivePlan},
      {path: 'sponsor/edit-plan/:planId', element: CreateActivePlan},
      {path: 'sponsor/activePlane', element: ActivePlanPage},
      {path: 'sponsor/old-plan', element: OldPlanPage},
      {path: 'loading-sponsor', element: Receipt},
      {path: 'sponsor/payment/success', element: Success},
      {path: 'sponsor/payment/failure', element: Failed},
      {path: 'payment/success', element: PaymentSuccess},
      {path: 'payment/failure/:ipg_type/:guid', element: PaymentFailure},
      {path: 'payment/plan/success', element: PaymentPlanSuccess},
      {
        path: 'payment/plan/failure/:ipg_type/:guid',
        element: PaymentFailure,
      },
      {path: 'payment/loading/:ipg_type/:guid', element: PaymentLoading},
      {
        path: 'payment/plan/loading/:ipg_type/:guid',
        element: PaymentPlanLoading,
      },

      // ==================== Notification + Short Link ====================
      {path: 'my-notifications', element: MyNotifications},
      {path: 'n', element: MyNotifications},

      // ==================== CHAT & MESSAGING ====================
      {path: 'my-chats', element: MyChats},
      {path: 'chat-form/:guid?', element: ChatsForm},
      {path: 'chat-form/:guid/add-picture', element: ChatFormAddImage},

      // ==================== USER ACCOUNT & PROFILE ====================
      {path: 'my-account', element: MyAccountWrapper},
      {path: 'edit/my-account/:guid', element: EditMyAccountWrapper},
      {path: 'edit/my-account/add-picture', element: AddPicture},
      {path: 'my-credits', element: MyCreditsPage},
      {path: 'my-credits/startLoanCredit', element: StartLoanCreditPage},
      {path: 'my-orders', element: MyOrders},
      {path: 'my-orders/:storeOrderGuid/:orderGuid', element: OrderDetail},
      {path: 'my-accesses', element: MyAccess},
      {path: 'my-favourite-adds', element: MyFavouriteAdd},

      // ==================== ADVERTISEMENT MANAGEMENT ====================
      {path: 'my-ads', element: MyAdds},
      {
        path: 'edit/advertisment/:guid/:advertisement_type',
        element: EditAdds,
      },
      {
        path: 'my-ads/requirement/:guid/:requirement_type',
        element: RequirementDetail,
      },
      {path: 'my-ads/advertisment/:guid', element: AdvertismentDetail},
      {
        path: 'advertisement_listing/:inputGroupName/:subInputGroupName?',
        element: AdvertisementList,
      },
      {path: 'products/:inputGroupName', element: ProductsPage},
      {
        path: 'product-shop-list/:inputGroupName/:subBrandGuid/:quantityPack?/:quantityPackUnit?',
        element: ProductShopsList,
      },
      {path: 'advertisement-list-for-all', element: AdvertisementListForAll},

      // ==================== ADVERTISEMENT REGISTRATION ====================
      {
        path: 'advertisement-registeration',
        element: AdvertisementRegisteration,
      },
      {
        path: 'advertisement-registeration/:inventoryGuid/:serviceType',
        element: AdvertisementRegisteration,
      },
      {
        path: 'advertisement-registeration/add/picture',
        element: AdverAddPicture,
      },
      {
        path: 'advertisement-register-subInput-list',
        element: SubInputList,
      },
      {path: 'advertisement-register-brand-list', element: BrandSelect},
      {
        path: 'advertisement-register-brand-list/sub-brand',
        element: SubBrandSelect,
      },
      {path: 'optional-registeration-info', element: OptionalInfoAR},

      // ==================== UPGRADE & PROMOTION ====================
      {path: 'upgrade/advertisement/account/:guid', element: UpgradeAccount},
      {
        path: 'upgrade/prmotion/card_to_card/:guid',
        element: UpgradePrmotionCardToCard,
      },
      {
        path: 'upgrade/plan/card_to_card/:guid',
        element: UpgradePlanCardToCard,
      },
      {
        path: 'upgrade/requirement/account/:guid',
        element: UpgradeAccountRequirement,
      },
      {path: 'account/promotion/:type_promotion', element: AccounPromotion},

      // ==================== STORE MANAGEMENT ====================
      {path: 'my-store', element: MyStore},
      {path: 'my-store-info', element: MyStoreInfo},
      {path: 'my-store-orders', element: MyStoreOrders},
      {
        path: 'my-store-sales-partnership-agreement/hasLicenseAgreement=false',
        element: MyStoreSalesPartnershipAgreement,
      },
      {
        path: 'my-store-sales-partnership-agreement/hasLicenseAgreement=true',
        element: MyStorePartnershipAgreementLicense,
      },
      {path: 'settlementAndPayouts', element: MyStoreSettlementsOrders},
      {path: 'manage-my-store-ads', element: ManageMyStoreAds},
      {path: 'edit-bulk-store-ads', element: EditBulkStoreAdsPage},
      {
        path: 'preview-and-edit-ad-price',
        element: PreviewAndEditAdPricePage,
      },
      {path: 'my-store-advertisement', element: MyStoreAdvertisement},
      {
        path: 'my-store-order-detail/:orderGuid',
        element: MyStoreOrderDetail,
      },
      {
        path: 'my-lab-Advertisement/:lab_guid',
        element: MyLabAdvertisement,
      },
      {
        path: 'my-store-comments-listing',
        element: MyStoreCommentsListing,
      },
      {path: 'my-store-comments/:guid', element: MyStoreComments},

      // ==================== STORE REGISTRATION ====================
      {path: 'register-store-lab', element: RegisterStoreLab},
      {path: 'register-lab', element: RegisterLab},
      {path: 'register-store/:storeType?', element: RegisterStore},
      {
        path: 'edit-register-store/store/:store_guid',
        element: EditRegisterStore,
      },
      {
        path: 'edit-register-store/:store_guid',
        element: EditRegisterStore,
      },
      {
        path: 'edit-register-store/lab/:lab_guid',
        element: EditRegisterLab,
      },
      {
        path: 'lab-store-additional-Main-info',
        element: LabStoreAdditionalMainInfo,
      },

      // ==================== LOCATION & MAPS ====================
      {path: 'add-location', element: AddLocation},
      {path: 'choose-location', element: ChooseLocation},
      {
        path: 'my-store-add-location-by-map',
        element: MyStoreAddLocationByMap,
      },
      {path: 'searching-location', element: SearchingLocation},
      {
        path: 'registering-searching-location',
        element: RegisteringSearchingLocation,
      },
      {path: 'my-store/add/picture', element: MyStoreAddPicture},

      // ==================== BRAND & PRODUCT MANAGEMENT ====================
      {path: 'my-store-brands', element: MyStoreBrandsPage},
      {path: 'brands', element: SelectedBrandsPage},
      {path: 'create-brand', element: CreateBrand},
      {path: 'create-brand/:brandId/add-product', element: AddProduct},
      // Brand Owner Routes
      {path: 'my-store-brands/brand/:brandId', element: MyStoreSubBrands},
      {
        path: 'my-store-brands/brand/:brandId/subBrand/:subBrandGuid',
        element: MyStoreSubBrandDetail,
      },
      // Public Brand Routes
      {path: 'brand/:brandId', element: BrandProducts},
      {
        path: 'brand/:brandId/subBrand/:subBrandId',
        element: ProductDetail,
      },
      {path: 'brand/:brandId/sale-agents', element: SaleAgentsPage},

      // ==================== SALE AGENTS ====================
      {path: 'my-store-sale-agents', element: MyStoreSaleAgents},
      {path: 'sale-agents/:assigner_store', element: SalesAgents},
      {
        path: 'sale-agent-list/:assigner_store',
        element: SaleAgentsList,
      },
      {
        path: 'store-sale-agent-list/:assigner_store',
        element: StoreSaleAgentsList,
      },
      {
        path: 'sale-agent-location-by-map/:assigner_store',
        element: SaleAgentLocationByMap,
      },
      {
        path: 'sale-agent-searching-location',
        element: SaleAgentSearchingLocation,
      },

      // ==================== LISTING & SEARCH ====================
      {path: 'shop-listing', element: ShopListing},
      {path: 'lab-listing', element: LabListing},
      {path: 'search-store', element: SearchStore},
      {path: 'offers-listing', element: OffersListing},
      {path: 'buyers-listing', element: BuyersListing},

      // ==================== DETAIL PAGES ====================
      {path: 'shop-card-detail/:guid', element: ShopDetails},
      {
        path: 'store-select-input-advertisement/:guid',
        element: ShopSelectInputAds,
      },
      {
        path: 'input-search-advertisement-result/:selectedInputGroup/:storeGuid/:inputGuid?',
        element: SelectShopAdvertisementByInput,
      },
      {path: 'lab-card-detail/:guid', element: LabDetails},
      {
        path: 'category-card-detail/:inputGroup/:guid',
        element: CategoryCardDetail,
      },
      {path: 'comments-listing/:guid', element: CommentsListing},

      // ==================== CONTENT & STORIES ====================
      {path: 'set-story/:guid', element: SetStory},
      {path: 'guide-story', element: GuideStory},

      // ==================== SUPPORT & INFORMATION ====================
      {path: 'rules', element: Rules},
      {path: 'backup', element: BackUp},
      {path: 'faq', element: Faq},
      {
        path: 'customers-point-of-view',
        element: CustomersPointOfView,
      },

      // ==================== VIOLATION REPORTS ====================
      {
        path: 'violation-report-store/:store_guid',
        element: ViolationReportStore,
      },
      {
        path: 'violation-report-advertisement/:ad_guid',
        element: ViolationReportAdvertisement,
      },
    ],
  },
];
